import Icon from './icons/Icon';

const Logo = ({ text = 'АРМ РРМ', className = '' }) => (
    <div className={`inline-flex items-center ${className}`}>
        <div className={`flex h-8 w-8 items-center justify-center rounded bg-brand-logo`}>
            <Icon />
        </div>

        <span className="ml-2 inline-flex text-sm font-semibold text-black dark:text-font-primary">{text}</span>
    </div>
);

export default Logo;
